<template>
<div>
  <div id="wjdcEdit" v-if="editFlag" v-loading="loading" element-loading-text="loading">
      <div id="wjdcView" class="pt15">
        <el-form class="el-form demo-form-inline" ref="wjdcForm" :model="wjdcForm" label-position="right" label-width="300px" :rules="wjdcRules">
          <el-row class="tr mb5">
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="22" style="text-align:left">
              <el-form-item label="Category of Your Major Products" prop="zycpList" id="cplx_btn_group">
                <el-button v-for="item in zycp_data" plain size="small" :key="item.codeValue" @click="selectCpfl(item.codeValue)">
                  <span v-text="item.codeName"></span>
                </el-button>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="22" style="text-align:left;margin-left: 300px;">
                <el-button type="primary" v-for="item in childrenCpfl" :key="item.codeValue" plain size="small" @click="selectCpfl2(item.codeValue)">
                  <span v-text="item.codeName"></span>
                </el-button>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
          <el-row id="childrenRow" class="tr mb5" style="text-align:left">
            <el-col :span="22" style="text-align: left;">
              <el-row id="tagRow" class="tr mb5">
                <el-col :span="19" style="text-align: left;margin-left: 300px;">
                  <el-checkbox-group v-model="wjdcForm.zycpList" id="cplx_chb_group">
                    <el-checkbox v-for="item in grandchildrenCpfl" :label="item.codeValue+item.codeName" :key="item.codeValue+item.codeName">{{item.codeName}}</el-checkbox>
                  </el-checkbox-group>
                </el-col>
              </el-row>
              <el-row id="tagRow" class="tr mb5">
                <el-col :span="19" style="text-align: left;margin-left: 200px;">
                  <el-tag v-for="tag in wjdcForm.zycpList" :key="tag" closable @close="handleTagClose(tag)" style="margin: 3px"  type= 'success'>
                    {{tag.substr(4)}}
                  </el-tag>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
          <el-row class="buttonSubmit">
            <el-col :span="24" class="editform-button">
              <el-button v-if="wjdcData.validateFlag=='T'" type="info" icon="el-icon-close" size="small" class="btn_submit" @click="cancel()">Cancel</el-button>
              <el-button type="success" icon="el-icon-check" size="small" class="btn_submit" @click="submitWjdc('wjdcForm')">Save</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
  </div>
  <div class="main-container" v-loading="loading" element-loading-text="loading" v-if="!editFlag">
    <div id="qywjdc" class="mb5">
      <el-row class="mb10">
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="21">
            <strong>Category of Your Major Products：</strong>
            <span v-text="wjdcData.zycp||'no'"></span>
          </el-col>
          <el-col :span="2">
              <el-button type="primary" icon="el-icon-edit" size="small" class="btn_submit" @click="editClick()">Edit</el-button>
            </el-col>
        </el-row>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props:{
    qyid: {
        type: String,
        required: true
    },
  },
  
  name: "wjdcEdit",
  data() {
    return {
      //当前用户
      currentUser: this.CONSTANT.currentUser,
      //问卷调查表单
      wjdcForm: {
        zycpList: []
      },
      wjdcRules: {
        zycpList: [
          {
            required: true,
            message: "Category of Your Major Products is required",
            trigger: "change"
          }
        ]
      },

      editFlag: false,
      //企业问卷调查
      wjdcData: {},
      //产品所属分类
      zycp_data: [],
      //问卷调查产品分类子类
      childrenCpfl: [],
      loading: false,
      grandchildrenCpfl:[]
    };
  },
  watch: {
    qyid(){
      if(this.qyid == 'newInsert'){
        this.editFlag = true;
      }else if(this.qyid != ''){
        this.findWjdcByQyid(this.qyid);
      }
    }
  },
  created: function() {
    this.getCpssfl(); //产品所属分类
  },
  methods: {
    //通过企业id查找问卷调查信息
    findWjdcByQyid: function(qyid) {
      let vm = this;
      vm.loading = true;
      var params = {
        qyid: qyid,
        deleteFlag: "N"
      };
      vm.$axios.post("/qywjdc/list", params).then(
        function(res) {
          if (res.data.result.length > 0) {
            this.wjdcData = JSON.parse(JSON.stringify(res.data.result[0]));
            var tempList = this.wjdcData.reserve1.split(",");
            var zycp = "";
            for (var i in tempList) {
              zycp = zycp + tempList[i].substr(4) + "、";
            }
            this.wjdcData.zycp = zycp.substr(0, zycp.length - 1);

            vm.wjdcForm = res.data.result[0];
            vm.wjdcForm.zycpList = [];
            var tempList = vm.wjdcForm.reserve1.split(",");
            for (var i in tempList) {
              vm.wjdcForm.zycpList.push(tempList[i]);
            }
            if(res.data.result[0].validateFlag == 'T'){
                vm.editFlag = false;
            }else{
                vm.editFlag = true;
            }
            
          } else {
            vm.editFlag = true;
          }
          vm.loading = false;
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },
    //根据代码集获取产品所属分类
    getCpssfl: function() {
      let vm = this;
      vm.$axios.get("/codelist/getZycpTree/CPLX_EN").then(
        function(res) {
          vm.zycp_data = res.data.result;
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },
    //选择产品分类，显示子类
    selectCpfl: function(codeValue) {
      //清空孙子
      this.grandchildrenCpfl = [];
      //遍历儿子
      for (var i in this.zycp_data) {
        if (this.zycp_data[i].codeValue == codeValue) {
          this.childrenCpfl = this.zycp_data[i].children;
        }
      }
    },

    //选择产品分类，显示子类
    selectCpfl2: function(codeValue) {
      for (var i in this.childrenCpfl) {
        if (this.childrenCpfl[i].codeValue == codeValue) {
          this.grandchildrenCpfl = this.childrenCpfl[i].children;
        }
      }
      //document.getElementById("childrenRow").innerHTML="";
    },
    //关闭标签
    handleTagClose: function(tag) {
      this.wjdcForm.zycpList.splice(this.wjdcForm.zycpList.indexOf(tag), 1);
    },
    //问卷调查提交（下一步）
    submitWjdc: function(formName) {
      let vm = this;
      if (vm.qyid == 'newInsert') {
        vm.$alert("Failed to save. Please fill in the Brief Information before filling in other information", 'Info', {
          confirmButtonText: 'ok'
        });
      }else{
        vm.$refs[formName].validate(valid => {
        if (valid) {
          vm.loading = true;
          var zycp = "";
          var reserve1 = "";
          for (var i in vm.wjdcForm.zycpList) {
            var str = vm.wjdcForm.zycpList[i].substr(0, 4) + ",";
            zycp += str;
            reserve1 += vm.wjdcForm.zycpList[i] + ",";
          }
           var params = {
            uuid: vm.wjdcForm.uuid,
            qyid: vm.qyid,
            zycp: zycp.substr(0, zycp.length - 1), //eg.1001,1002,1003
            deleteFlag: "N",
            xgrid: vm.currentUser.userid,
            xgrmc: vm.currentUser.username,
            reserve1: reserve1.substr(0, reserve1.length - 1), //eg.1001消防车
            validateFlag: 'T'
          };
          vm.$axios.post("/qywjdc/doInsertOrUpdateWjByVo", params).then(
              function(res) {
                if (res.data.result != null && res.data.result != "") {
                  vm.$message({
                    message: "Major Product Information has been saved!",
                    type: "success"
                  });
                 
                  vm.loading = false;
                  //this.$emit("getActive",  3);
                  vm.editFlag = false;
                  vm.findWjdcByQyid(this.qyid);
                } else {
                  vm.$message({
                    message: "Major Product Information save failed",
                    type: "error"
                  });
                  vm.loading = false;
                }
              }.bind(vm),
              function(error) {
                vm.loading = false;
                console.log(error);
              }
            );
        } else {
          setTimeout(() => {
              var isError = document.getElementsByClassName("is-error");
              isError[0].querySelector('input,textarea').focus();
            }, 100);
          console.log("error submit!!");
          return false;
        }
      });
      }
    },

    editClick: function(){
      this.editFlag = true;
    },
    cancel: function(){
      this.findWjdcByQyid(this.qyid);
    }
  }
};
</script>

<style lang="scss">
#wjdcEdit {
  .mb5 {
    margin-bottom: 5px;
  }
  
  .el-card__body {
    padding: 10px 0px 10px 0px;
  }
  .el-message {
    z-index: 10005 !important;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  .el-dialog {
    width: 45%;
  }
  .el-button--small {
    padding: 9px 9px;
  }

  .card_title_font{
    line-height: 40px;
  }
  .clearfix{
    height: 40px;
  }
  #wjdcView .el-input-number--small{
    width: 30%;
    float: left;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/exhprediction/exhpredictionEditEng/Wjdc.vue